import alt from 'components/Dispatcher';
import CardReasonSource from 'sources/CardReasonSource';
import generateAsyncActions from 'utils/generateAsyncActions';

class CardReasonActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions(
        'fetchAll',
        'fetchReasonSchemesForScoringScheme',
        'fetchReasonSchemesForCall',
        'fetchReasonSchemesForScorecard',
        'fetchReasonSchemesForCurrentUser'
      )
    );
  }
  fetchAll() {
    return dispatch => {
      dispatch();
      return CardReasonSource.fetchAll().then(this.fetchAllSuccess, this.fetchAllError);
    };
  }

  fetchReasonSchemesForScoringScheme(scoringScheme) {
    return dispatch => {
      dispatch(scoringScheme);
      return CardReasonSource.fetchReasonSchemesForScoringScheme(scoringScheme).then(
        this.fetchReasonSchemesForScoringSchemeSuccess,
        this.fetchReasonSchemesForScoringSchemeError
      );
    };
  }

  fetchReasonSchemesForCall(scorecardIds) {
    return dispatch => {
      dispatch(scorecardIds);
      return CardReasonSource.fetchReasonSchemesForCall(scorecardIds).then(
        this.fetchReasonSchemesForCallSuccess,
        this.fetchReasonSchemesForCallError
      );
    };
  }
  fetchReasonSchemesForScorecard(scorecardId) {
    return dispatch => {
      dispatch(scorecardId);
      return CardReasonSource.fetchReasonSchemesForScorecard(scorecardId).then(
        this.fetchReasonSchemesForScorecardSuccess,
        this.fetchReasonSchemesForScorecardError
      );
    };
  }

  fetchReasonSchemesForCurrentUser() {
    return dispatch => {
      dispatch();
      return CardReasonSource.fetchReasonSchemesForCurrentUser().then(
        this.fetchReasonSchemesForCurrentUserSuccess,
        this.fetchReasonSchemesForCurrentUserError
      );
    };
  }
}

export default alt.createActions(CardReasonActions);
